<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" />
      <img :src="banner_m" v-else />
      <!-- <div class="banner_title" v-if="clientWidth < 750">{{ banner_title }}</div> -->
    </div>
    <div class="module">
      <!-- <iframe src="https://www.pailixiang.com/m/embedalbum_ia4327734145.html"  frameborder="0"></iframe> -->
      <!-- <iframe src="https://wechatmini-10.photoplus.cn/live/39581688"  frameborder="0"></iframe> -->
      <iframe src="https://live.pailixiang.com/album/a13707461037" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import { Res_Url2026 } from "@/utils/ApiToken.js";
export default {
  data() {
    return {
      banner: Res_Url2026+"/common/photo_banner.png",
      banner_m: Res_Url2026+"/common/photo_banner_m.png",  
    };
  },
  components: {},
  mounted() {},
  methods: {},
  watch: {},
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
};
</script>


<style lang="scss" scoped>
$mobil_base: 750;

@function vw($true) {
  @return ($true / $mobil_base) * 100vw;
}

.banner {
  position: relative;

  img {
    width: 100%;
  }

  .banner_title {
    top: calc(225 / 1920) * 100vw;
    left: calc(490 / 1920) * 100vw;
    width: calc(225 / 1920) * 100vw;
    text-align: center;
    position: absolute;
    font-size: calc(40 / 1920) * 100vw;
    font-weight: bold;
    color: #ffffff;
    line-height: calc(47 / 1920) * 100vw;
    letter-spacing: calc(4 / 1920) * 100vw;
  }
}


.module{
  width: 100%;
  // height: 100%;
  height: calc(100vh - 150px);
}
iframe{
  width: 100%;
  height: 100%;
}


@media (max-width: 1200px) and (min-width: 768px) {
  .banner {
    .banner_title {
      top: pw(130);
      width: pw(140);
      font-size: pw(24);
      line-height: pw(47);
      letter-spacing: pw(4);
    }
  }
}
@media (max-width: 768px) {
  .banner {
    .banner_title {
      width: vw(216);
      font-size: vw(40);
      top: vw(218);
      left: vw(195);
    }
  }
  .module{
    width: 100%;
    height: calc(100vh - vw(212));
  }
}
</style>